module.exports = __webpack_public_path__ + "img/mobile-mapping-zustand.a137034e.png";